import {getFileUrl} from '../api/file';
import md5 from 'js-md5';
import axios from 'axios';

const baseTask = `/mgr/task-engine`

export const getQueryStringByName = function (name) {
    var result = location.search.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'))
    if (result == null || result.length < 1) {
        return ''
    }
    return result[1]
}

export const transformData = function (data) {
    const params = new FormData()
    for (const item in data) {
        params.append(item, data[item])
    }
    return params
}

export const DateFormat = function (date, fmt) {
    fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
    if (date === null || typeof date === 'undefined' || date === '') {
        return null
    } else {
        // 时间要转成obj，否则报错
        date = new Date(date)
    }
    var o = {
        'M+': date.getMonth() + 1, // 月
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
    }
    return fmt
}
export const openLink = (url) => {
    window.open(url, 'blank')
}
// 转换文件地址并在浏览器中打开下载
export const handleTransUrlAndDownLoadFile = (url) => {
    const query = {
        url
    }
    getFileUrl(query).then(res => {
        if (res.data.code === 0) {
            const url = res.data.data.data
            openLink(url)
        }
    })
}

// 转换文件下载地址
export function getFileUrlLarger(bucketName, fileName) {
    return request({
        url: `${base}/base/getFileUrl?url=${bucketName}_${fileName}`, method: 'get',
    })
}

/**
 * 分片上传函数 支持多个文件
 * @param options
 * options.file 表示源文件
 * options.pieceSize 表示需要分片的大小 默认是5m
 * options.fileUrl 整个文件的上传地址
 * progress 进度回调
 * success 成功回调
 * error 失败回调
 */
export const uploadByPieces = ({files, pieceSize = 5, progress, success, error}) => {
    if (!files || !files.length) return
    // 上传过程中用到的变量
    let fileList = [] // 总文件列表
    let progressNum = 1 // 进度
    let successAllCount = 0 // 上传成功的片数
    // let currentAllChunk = 0 // 当前上传的片数索引
    let AllChunk = 0 // 所有文件的chunk数之和
    let AllFileSize = 0 // 所有文件size


    // 获取md5
    const readFileMD5 = (files) => {
        // 读取每个文件的md5
        files.map((file, index) => {
            let fileRederInstance = new FileReader()
            fileRederInstance.readAsBinaryString(file)
            fileRederInstance.addEventListener('load', e => {
                let fileBolb = e.target.result
                let fileMD5 = md5(fileBolb)
                if (!fileList.some((arr) => arr.md5 === fileMD5)) {
                    fileList.push({md5: fileMD5, name: file.name, file})
                    AllFileSize = AllFileSize + file.size
                }
                if (index === files.length - 1) readChunkMD5(fileList)
            }, false)
        })
    }
    const getChunkInfo = (file, currentChunk, chunkSize) => {
        let start = currentChunk * chunkSize
        let end = Math.min(file.size, start + chunkSize)
        let chunk = file.slice(start, end)
        return {start, end, chunk}
    }
    // 针对每个文件进行chunk处理
    const readChunkMD5 = (fileList) => {
        fileList.map((currentFile, fileIndex) => {
            const chunkSize = pieceSize * 1024 * 1024 // 5MB一片
            const chunkCount = Math.ceil(currentFile.file.size / chunkSize) // 总片数

            const certificateData = {
                filename: currentFile.name, num: chunkCount,
            }
            getCertificate(certificateData).then(async res => {
                if (res.data.code === 0) {
                    AllChunk = AllChunk + chunkCount // 计算全局chunk数
                    // let fileSize = currentFile.file.size // 文件大小
                    // 针对单个文件进行chunk上传
                    const resData = res.data.data

                    for (let i = 0; i < chunkCount; i++) {
                        const {chunk} = getChunkInfo(currentFile.file, i, chunkSize)
                        // let chunkFR = new FileReader()
                        // chunkFR.readAsBinaryString(chunk)
                        // chunkFR.addEventListener('load', e => {
                        //   let chunkBolb = e.target.result
                        //   let chunkMD5 = md5(chunkBolb)
                        //   // this.readingFile = false
                        //
                        //   // bucketName: "manage"
                        //   // createTime: 1614309462937
                        //   // fileName: "bigfile/2021-02-26/0f948cdcb4f24db5be41d1833aeb8d9a.zip"
                        //   // originFileName: "任务管理系统 - 副本.zip"
                        //   // partNumber: 0
                        //   // totalPartNumber: 12
                        //   // uploadId: "345cc3b7-ee67-463b-b641-e5c3ff2f5e05"
                        //
                        //   uploadChunk(currentFile, {chunkMD5, chunk, currentChunk: i, chunkCount}, fileIndex, resData)
                        // }, false)
                        await uploadChunk(currentFile, {chunk, currentChunk: i, chunkCount}, fileIndex, resData)
                    }
                }
            }).catch(e => {
                error && error(e)
            })
        })
    }
    // 更新进度
    const progressFun = (currentFile) => {
        progressNum = Math.ceil(successAllCount / AllChunk * 100)
        progress(progressNum, currentFile)
    }
    // 对分片已经处理完毕的文件进行上传
    // const uploadFile = (currentFile) => {
    //   let makeFileForm = new FormData()
    //   makeFileForm.append('file', currentFile.file)
    //
    //   fileUpload(makeFileForm).then(res => {
    //     progressFun()
    //     res.file_name = currentFile.name
    //     success && success(res)
    //     successAllCount++
    //   }).catch(e => {
    //     error && error(e)
    //   })
    // }
    const uploadChunk = (currentFile, chunkInfo, fileIndex, {bucketName, uploadId, partNumber, fileName}) => {
        currentFile.fileName = fileName
        return new Promise((resolve, reject) => {
            let fetchForm = new FormData()
            fetchForm.append('file', chunkInfo.chunk)
            // const chunkUrl = `/uploadPart/{bucketName}/{uploadId}/{partNumber}`
            const chunkUrl = `${config.uploadFileServer}/uploadPart/${bucketName}/${uploadId}/${chunkInfo.currentChunk + 1}`

            axios({
                url: chunkUrl, method: 'post', headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }, data: fetchForm,
            })
                .then(res => {
                    resolve(res)
                    progressFun(currentFile)
                    if (chunkInfo.currentChunk <= chunkInfo.chunkCount - 1) {
                        successAllCount++
                        if (chunkInfo.currentChunk + 1 === chunkInfo.chunkCount) {
                            const successData = {
                                bucketName, fileName, name: currentFile.name, size: AllFileSize,
                            }
                            success && success(successData)
                        }
                    }
                }).catch((e) => {
                error && error(e)
                reject(e)
            })
        })

    }
    readFileMD5(files) // 开始执行代码
}

/**
 * 文件大小转换
 * @param   fileByte    {Number} 文件byte
 * @return  {String}
 * */
export function getFileSize(fileByte) {
    var fileSizeByte = fileByte;
    var fileSizeMsg = "";
    if (fileSizeByte < 1048576) fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + "KB"; else if (fileSizeByte == 1048576) fileSizeMsg = "1MB"; else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + "MB"; else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = "1GB"; else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + "GB"; else fileSizeMsg = "文件超过1TB";
    return fileSizeMsg;
}

// 获取文件后缀名 "xxx.png"  => ".png"
export const getFileSuffix = (filename) => {
    return filename.substring(filename.lastIndexOf("."), filename.length)
}


// 邮箱截取 前缀 xxx@qq.com> => xxx
export function getMailPrefix(str) {
    if (!str) return ''
    const reg = /^(\w)+(\.\w+)*/g
    if (!reg.test(str)) return ''
    return str.match(reg)[0]
}

// 邮箱截取 aaa<bbb@qq.com> => bbb@qq.com
export function getMailStr(str) {
    const reg = /([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})/g
    return str.match(reg) ? (str.match(reg)[0]) : ''
}

// 换行 '↵' => '\n'
export const transEnterTextBr = (str) => {
    return str.replace(/(\r\n|\n|\r)/gm, "<br />")
}

/**
 * xss 过滤
 * */
export const xssFilter = (htmlStr) => {
    const whiteList = xss.getDefaultWhiteList()
    const myWhiteList = JSON.parse(JSON.stringify(whiteList))
    const keys = Object.keys(myWhiteList)
    keys.forEach(key => {
        myWhiteList[key].push('style')
    })
    const myxss = new xss.FilterXSS({
        whiteList: myWhiteList, css: true
    })
    return myxss.process(htmlStr)
}

const CNDateDay2 = [{week: '星期日', num: 0}, {week: '星期一', num: 1}, {week: '星期二', num: 2}, {
    week: '星期三', num: 3
}, {week: '星期四', num: 4}, {week: '星期五', num: 5}, {week: '星期六', num: 6}]


export const formatToCNDateDay2 = (dateDay) => {
    let str = ''
    CNDateDay2.forEach(item => {
        if (item.num === dateDay) {
            str = item.week
        }
    })
    return str
}


export function getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font; // 设置字体样式，必须设置为与实际文本相同的样式
    const width = context.measureText(text).width.toFixed(0)
    console.log(width, 'text', text)
    return width;
}

export function getTextLength(str) {
    if (!str) return 0; // 排除 null、undefined、''

    let len = 0;
    for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
            len += 2;
        } else {
            len += 1;
        }
    }
    return len;
}

export function formatText(str, limit = 9, isTag) {
    let len = 0;
    let result = '';
    let limitTag = 0;
    if (isTag) {
        limitTag = limit - 9
    } else {
        limitTag = limit
    }
    for (let i = 0; i < str.length; i++) {
        const char = str[i];
        len += char.charCodeAt(0) > 127 ? 2 : 1;
        if (len > limitTag * 2) { // 中文占2，英文占1，9个字 = 18长度
            result += '...';
            break;
        }
        result += char;
    }
    return result;
}

export function getColumnWidth(itemValue, tableData, label, type) {
    switch (itemValue) {
        case 'customerType':
        case 'customerCode':
        case 'customerOrigin':
            return 160;
        case 'createName':
            return 80;
        case 'customerLevel':
            return 80;
        case 'maiContactVOList':
            return 70;
        case 'mangerVOList':
            if (type === 'public') {
                return 100;
            } else {
                return 70;
            }
        case "lastTime":
            return 150;
        case "setting":
            return 120;
        case "zoneAddress":
            return 80;
        case "applyTime":
            return 150;
        case "followTime":
            return 150;
        case "auditName":
            return 70;
        case "userName":
            return 70;
        case "auditStatus":
            return 120;
        default:
            return 'auto'
        // flexWidth(itemValue, tableData, label);
    }
}

// ai 对话详情 到 对话框

export function processChatData(data) {
    const processedData = [];
    const questionMap = {};

    data.forEach(item => {
        const {question, content} = item;

        // 处理 Client 部分
        if (!questionMap[question]) {
            questionMap[question] = {
                key: "Client", content: question
            };
            processedData.push(questionMap[question]);
        }

        // 处理 AI 部分
        let lastItem = processedData[processedData.length - 1];
        if (lastItem.key === "AI" && lastItem.isArray) {
            lastItem.content.push({
                key: "AI", content, isCompletedAIChat: true
            });
        } else if (lastItem.key === "AI" && !lastItem.isArray) {
            lastItem.isArray = true;
            lastItem.content = [{key: "AI", content: lastItem.content, isCompletedAIChat: true}, {
                key: "AI", content, isCompletedAIChat: true
            }];
        } else {
            processedData.push({
                key: "AI", isArray: false, content, isCompletedAIChat: true
            });
        }
    });

    // 如果 AI 的 content 只有一条回复，则取消 isArray
    processedData.forEach(item => {
        if (item.key === "AI" && item.isArray && item.content.length === 1) {
            item.isArray = false;
            item.content = item.content[0].content;
        }
    });

    return processedData;
}


/**
 * 文件 置顶排序
 * @param folders
 * @returns {*}
 */
export function sortFolders(folders) {
    if (folders) {
        return folders.slice().sort((a, b) => {
            // 判断是否都为置顶
            if (a.isTop === 1 && b.isTop === 1) {
                // orderNum 越小越靠前，null 视为无穷大
                const aOrder = a.orderNum !== null ? a.orderNum : Infinity;
                const bOrder = b.orderNum !== null ? b.orderNum : Infinity;
                return aOrder - bOrder;
            }

            // 只有 a 是置顶，a 靠前
            if (a.isTop === 1 && b.isTop !== 1) {
                return -1;
            }

            // 只有 b 是置顶，b 靠前
            if (a.isTop !== 1 && b.isTop === 1) {
                return 1;
            }

            // 都不是置顶，不变顺序
            return 0;
        });
    } else {
        return folders
    }
}

/**
 * 高亮关键词
 * @param {String} text 要处理的文本
 * @param {String} keyword 关键词
 * @param {String} [highlightClass='highlight'] 高亮的 class 名，默认 highlight
 * @returns {String} 返回带高亮的 HTML 字符串
 */
export function highlightKeyword(text, keyword, highlightClass = 'highlight_search') {
    if (!keyword) return text
    const escapedKeyword = keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') // 防止正则出错
    const reg = new RegExp(`(${escapedKeyword})`, 'gi')
    console.log(text, text.replace(reg, `<span class="${highlightClass}">$1</span>`), 'ddddd')
    return text.replace(reg, `<span class="${highlightClass}">$1</span>`)
}


/**
 * 分段注入 HTML，支持间隔延迟，避免卡顿
 * @param targetRef Vue 的 ref 目标
 * @param html 要注入的 HTML 内容
 * @param chunkSize 每段大小，默认 10000 字符
 * @param delay 每段之间的延迟时间（ms），默认 30ms
 * @param done 注入完成后的回调
 */
// export default function createGradualInjector(contentHtml, html, templateHtml, chunkSize = 16000) {
//     contentHtml.value = ''
//     let index = 0
//     const totalLength = html.length
//     // 最小的长度是 模版的长度
//     const chunkSizeComputed = templateHtml?.length + html.length < chunkSize ? html.length : html.length * 0.3 > chunkSize ? chunkSize : html.length;
//     const totalChunks = Math.ceil(totalLength / chunkSizeComputed)
//
//     const injectNextChunk = (editor) => {
//         if (index >= totalLength) return false
//
//         // 重新获取当前用户已有的内容
//         let currentContent = ""
//         if (index === 0) {
//             // 第一次切片
//             currentContent = ""
//         } else {
//             // 后面的切片
//             currentContent = editor.getContent() || ''
//             console.log(editor, currentContent, 'editorRef')
//         }
//
//         // 当前要注入的切片
//         const chunk = html.slice(index, index + chunkSizeComputed)
//
//         // 直接通过 editor API 更新内容
//         const newContent = currentContent + chunk
//
//         // 同步外部状态
//         contentHtml.value = newContent
//
//         index += chunkSizeComputed
//         return true
//     }
//
//     const hasMore = () => index < totalLength
//
//     const getStatus = () => {
//         const currentChunk = Math.floor(index / chunkSizeComputed)
//         const remainingChunks = totalChunks - currentChunk
//         const injectedContent = contentHtml.value
//         const remainingContent = html.slice(index)
//
//         return {
//             totalChunks,
//             currentChunk,
//             remainingChunks,
//             injectedContent,
//             remainingContent,
//             progress: `${currentChunk}/${totalChunks}`,
//         }
//     }
//
//     return {
//         injectNextChunk, hasMore, getStatus,
//     }
// }

// 切片优化
// export default function createGradualInjector(contentHtml, html, templateHtml, chunkSize = 16000) {
//     contentHtml.value = ''
//     let index = 0
//     const totalLength = html.length
//
//     // 根据你的逻辑动态计算 chunk size
//     const chunkSizeComputed = templateHtml?.length + html.length < chunkSize ? html.length : html.length * 0.3 > chunkSize ? chunkSize : html.length
//
//     const totalChunks = Math.ceil(totalLength / chunkSizeComputed)
//
//     /**
//      * 安全切片：保证不会切断 "<tag ...>"
//      */
//     const getSafeSliceEnd = (start) => {
//         let end = start + chunkSizeComputed
//
//         if (end >= totalLength) return totalLength
//
//         // 尝试往右扩展，直到遇到 '>'
//         while (end < totalLength) {
//             const char = html[end]
//             if (char === '>') {
//                 end += 1
//                 break
//             }
//             end++
//         }
//
//         return end
//     }
//
//     const injectNextChunk = (editor) => {
//         if (index >= totalLength) return false
//
//         let currentContent = ""
//         if (index !== 0) {
//             currentContent = editor.getContent() || ''
//         }
//
//         // 关键改动
//         const safeEnd = getSafeSliceEnd(index)
//         const chunk = html.slice(index, safeEnd)
//         const newContent = currentContent + chunk
//
//         contentHtml.value = newContent
//         index = safeEnd
//
//         return true
//     }
//
//     const hasMore = () => index < totalLength
//
//     const getStatus = () => {
//         const currentChunk = Math.floor(index / chunkSizeComputed)
//         const remainingChunks = totalChunks - currentChunk
//
//         return {
//             totalChunks,
//             currentChunk,
//             remainingChunks,
//             injectedContent: contentHtml.value,
//             remainingContent: html.slice(index),
//             progress: `${currentChunk}/${totalChunks}`,
//         }
//     }
//
//     return {
//         injectNextChunk, hasMore, getStatus,
//     }
// }

export default function createGradualInjector(contentHtml, contents) {
    contentHtml.value = "";
    let pageIndex = 0; // 当前页数（从 0 开始）

    const totalPages = contents.length;

    const injectNextChunk = (editor) => {
        if (pageIndex >= totalPages) return false;

        const currentContent = pageIndex === 0 ? '' : (editor.getContent() || '');

        // 当前页内容
        const pageContent = contents[pageIndex];

        // 累加
        const newContent = currentContent + pageContent;

        // 保存
        contentHtml.value = newContent;

        pageIndex++;
        return true;
    };

    const hasMore = () => pageIndex < totalPages;

    const getStatus = () => {
        return {
            totalPages,               // 总页数
            currentPage: pageIndex,   // 已注入到第几页
            remainingPages: totalPages - pageIndex, injectedContent: contentHtml.value,          // 当前已注入内容
            remainingContent: contents.slice(pageIndex).join(""), // 剩余所有页
            progress: `${pageIndex}/${totalPages}`,
        };
    };

    return {
        injectNextChunk, hasMore, getStatus,
    };
}

export function splitHtmlByOriginalMessage(html, span = 3, includeBeforeBlock0 = false) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // 找到所有 block（marker 的父节点）
    const markers = Array.from(doc.querySelectorAll("*")).filter((el) => el.textContent.trim() === "------------------ Original Message ------------------");

    // ❗ 若没有任何 marker，表示内容中并没有 block —— 无需切割，返回整段内容
    if (markers.length === 0) {
        return {
            blocks: [], contents: [html],  // 直接整个内容放入 contents
            positions: []
        };
    }

    // 找到所有 block HTML（父元素）
    const blocks = markers.map((m) => m.parentElement.outerHTML);

    // 顺序查找 block 在 html 中的位置
    const positions = [];
    let searchPos = 0;

    for (let i = 0; i < blocks.length; i++) {
        const block = blocks[i];
        let pos = html.indexOf(block, searchPos);

        // indexOf 找不到时做一次容错
        if (pos === -1) pos = html.indexOf(block);

        positions.push(pos);

        // 下次搜索从当前 block 后继续
        searchPos = pos + block.length;
    }

    const contents = [];

    // block0 之前的 HTML 作为 prefix（可选）
    const prefix = includeBeforeBlock0 && positions[0] > 0 ? html.slice(0, positions[0]) : "";

    // ⚡按 span 分组切片
    for (let i = 0; i < blocks.length; i += span) {
        const start = positions[i];

        // 下一组的 block 位置
        const nextIndex = i + span;
        const end = nextIndex < positions.length ? positions[nextIndex] : html.length;

        let content = html.slice(start, end);

        // 第一组加 prefix
        if (i === 0 && prefix) {
            content = prefix + content;
        }

        contents.push(content);
    }

    return {blocks, contents, positions};
}

export function moveEmptyToEndAndSort(list) {
    return list.slice().sort((a, b) => {
        if (a === '' && b !== '') return 1
        if (a !== '' && b === '') return -1
        return a.localeCompare(b)
    })
}

export function productSortSwitch(productSort) {
    switch (productSort) {
        case 1:
            return "userinfo.vip.service.1";
        case 2:
            return "userinfo.vip.service.2";
        case 3:
            return "userinfo.vip.service.3";
        case 4:
            return "userinfo.vip.service.4"
        case 5:
            return "common.generaluser.pro";
        case 6:
            return "vip.type.1";
        case 7:
            return "vip.type.2";
        case 8:
            return "vip.type.3"
        default:
            return "common.unknown"
    }
}


